import { LabelSmall } from "../../../text_display/main_content_text_styling";
import { InputElementMultilineTextArea } from "../../../text_inputs/main_content_inputs";

export function FormElementBiomaterialsWhichMarkers({ changeFunction }) {
  return (
    <>
      <LabelSmall>
        Which Marker(s) Should Be Measured?
      </LabelSmall>
      <InputElementMultilineTextArea
        onChange={
          (event) => {
            changeFunction(event, "biomaterial_marker");
          }
        }
      />
    </>
  )
}
